import * as React from "react";
import { observer } from "mobx-react";
import { getPrePacksPrefix } from ".././../../components";
import { PrePacksHeader } from "../../PrePacksHeader";
import { PrePacksLazyRender } from "../../PrePacksLazyRender";
import { PrePack } from "../../PrePack";
import { PrePackSelection } from "../../PrePackSelection";
export const LeaguePrePacksContent = React.memo(observer(function LeaguePrePacksContent(props) {
    const baseClassName = getPrePacksPrefix("prePacks");
    const eventClassName = getPrePacksPrefix("event");
    const prePacks = props.chunkedPrePacks.getPrePacks(props.event.eventId);
    return (React.createElement("div", { className: `${eventClassName}-per-league`, "data-testid": "wrapper-event-per-league-prepacks" },
        React.createElement(PrePacksHeader, Object.assign({}, {
            eventName: {
                type: props.event.nameStructure.type,
                props: { name: props.event.nameStructure.name }
            },
            startDate: props.event.startDate,
            scoreboard: props.scoreboard,
            getEventPageNavLink: props.getEventPageNavLink,
            tags: props.event.tags,
            sgpBadgeTitle: props.dict.SgpBadgeTitle,
            renderSGPNavLink: props.renderSGPNavLink
        })),
        React.createElement("ul", { className: baseClassName },
            React.createElement(PrePacksLazyRender, Object.assign({ key: `chunk-pre-pack-per-event-id-chunk_${props.event.eventId}`, childrenLength: 3 }, props.chunkedPrePacks.lazyRendering), prePacks.map(p => React.createElement(PrePack, Object.assign({}, p, { key: `pre-pack-id-${p.id}` }), p.selections.map(s => React.createElement(PrePackSelection, Object.assign({}, s, { key: `pre-pack-selection-id-${s.id}` }))))))),
        props.viewMore));
}));
//# sourceMappingURL=LeaguePrePacksContent.js.map